export default {"src":"/_next/static/media/icon_behavior.3fd80271.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};